import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { getDriveit, driveitcreate, driveitarchive } from '../../api/api';
import { parseISO, differenceInDays } from 'date-fns';
import FlatList from 'flatlist-react';
import { faPlus, faFileImport, faFileExport, faCopy, faTrash  } from '@fortawesome/free-solid-svg-icons';
import DrawerNavigation from '../../utils/DrawerNavigation.js';
import { useMediaQuery } from 'react-responsive';
import myinventory from '../../assets/myinventory_mobile_logo.svg';
import myinventoryIcone from '../../assets/myinventory-icone.svg';
import atos from '../../assets/atos-logo.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../../styles/Buttons.css';
import '../../styles/Texts.css';
import '../../styles/Utils.css';
import '../../styles/Alinhamento.css';
import '../../styles/Imagens.css';

function Agendamentos() {
    const navigate = useNavigate();
    const location = useLocation();
    const [equipamentos, setequipamentos] = useState([]);
    const [filtroSelecionado, setFiltroSelecionado] = useState('');
    const user = location.state?.user || localStorage.getItem('user');
    const isBigScreen = useMediaQuery({ query: '(min-width: 481px)' });
    const [filterValue, setFilterValue] = useState('');
    const [filterMenuOpen, setFilterMenuOpen] = useState(false);
    const [visibleFieldsMenuOpen, setVisibleFieldsMenuOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [visibleFields, setVisibleFields] = useState({
        numero_serie: true,
        id_modelo: false,
        room: true,
        floor: false,
    
    });

    const toggleFieldVisibility = (field) => {
        setVisibleFields(prevState => ({
            ...prevState,
            [field]: !prevState[field]
        }));
    };

    useEffect(() => {
        if (user === undefined) {
            //navigate('/');
            // eslint-disable-line react-hooks/exhaustive-deps  
        }
    },);
    const [searchValue, setSearchValue] = useState("");

    const handleFilterChange = (value) => {
        setFiltroSelecionado(value);
        setFilterValue(value);
        setFilterMenuOpen(false);
    };

    const filtered = equipamentos.filter(equipamento => {
        const status = equipamento.encontrado;
        const data = equipamento.alterado_em;

        if (filterValue === 'ENCONTRADO') return status === 'ENCONTRADO';
        if (filterValue === 'NÃO ENCONTRADO') return status === 'NÃO ENCONTRADO';
        if (filterValue === 'DESAPARECIDO') return status !== 'ENCONTRADO' && status !== 'NÃO ENCONTRADO';
        if (filterValue === 'RECENTE') {
        if (!data) return false;
        return differenceInDays(new Date(), parseISO(data)) <= 30;
    }
        return true;
    });
    
    const fetchdriveit = async () => {        
        const response = await getDriveit();        
        const equipamento = response.map((r) => ({
            ...r.fields,
            pk: r.pk
        }));
        setequipamentos(equipamento);
        localStorage.setItem('equipamentos', JSON.stringify(equipamento));
        setFilterValue('')
        setLoading(false);
        
    };

    useEffect(() => {
        const storedEquipamentos = localStorage.getItem('equipamentos');
        if (storedEquipamentos) {
            setequipamentos(JSON.parse(storedEquipamentos));
            setLoading(false);
        } else {
            fetchdriveit();
        }
    }, []);

    const archive = async () => {
        const confirmar = window.confirm("Tem certeza que deseja arquivar todos equipamentos?");
        if (!confirmar) {
            return;
        }

        setLoading(true);
        const archive = await driveitarchive();
        const response = await getDriveit();
        const equipamento = response.map((r) => ({
            ...r.fields,
            pk: r.pk
        }));
        setequipamentos(equipamento);
        localStorage.setItem('equipamentos', JSON.stringify(equipamento));
        setLoading(false);
        setFilterValue('');
    };


    const handleFile = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = async (evt) => {
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: 'binary' });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const jsonData = XLSX.utils.sheet_to_json(ws, { defval: '' });

        const campoMapeado = {
        SERIAL: 'numero_serie',
        HOSTNAME: 'nome',
        ROOM: 'room',
        FLOOR: 'floor',
        MODELO: 'id_modelo',
        STATUS: 'encontrado',
        GERAR_ETIQUETA: 'verificacao_etiqueta',
        TRAVA_SEGURANCA: 'trava_seguranca',
        DATA: 'alterado_em',
        OBSERVAÇÃO: 'comentarios',
        };
       
        const convertidos = jsonData.map((equipamento) => {
        const convertido = {};
        for (const [colunaExcel, campoAPI] of Object.entries(campoMapeado)) {
            convertido[campoAPI] = equipamento[colunaExcel];
        }
        return convertido;
        });
        
        for (const item of convertidos) {
        await driveitcreate(user, item);
        }
        if (navigator.onLine) {
                const response = await getDriveit();
                const equipamento = response.map((r) => ({
                    ...r.fields,
                    pk: r.pk
                }));
                localStorage.setItem('equipamentos', JSON.stringify(equipamento));                
                setequipamentos(equipamento);
                setFilterValue('')
                alert('Importação finalizada com sucesso.');
                
        }    
        
    };

    reader.readAsBinaryString(file);
    };    
    
    const handleExport = () => {
        // Mapeamento reverso dos campos para nomes de colunas do Excel
        const campoMapeadoReverso = {
            numero_serie: 'SERIAL',
            nome: 'HOSTNAME',
            room: 'ROOM',
            floor: 'FLOOR',
            id_modelo: 'MODELO',
            encontrado: 'STATUS',
            verificacao_etiqueta: 'GERAR_ETIQUETA',
            trava_seguranca: 'TRAVA_SEGURANCA',
            alterado_em: 'DATA',
            analista: 'ANALISTA',
            comentarios: 'OBSERVAÇÃO',
            fora_da_base: 'FORA_DA_BASE',
            
        };

        const dadosParaExportar = equipamentos.map((equip) => {
            const convertido = {};
            for (const [campoAPI, nomeExcel] of Object.entries(campoMapeadoReverso)) {
                let valor = equip[campoAPI] || '';

                if (campoAPI === 'alterado_em' && valor) {
                    // Se for string ISO tipo "2025-07-17T19:22:17" ele corta o 'T' e depois
                    if (typeof valor === 'string' && valor.includes('T')) {
                        valor = valor.split('T')[0];
                    } else {
                        
                        try {
                            const date = new Date(valor);
                            valor = date.toISOString().split('T')[0];
                        } catch {
                            
                        }
                    }
                }
                convertido[nomeExcel] = valor;
            }
            return convertido;
        });

        const ws = XLSX.utils.json_to_sheet(dadosParaExportar);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Equipamentos');

        XLSX.writeFile(wb, 'export.xlsx');
    };

    const renderItem = (equipamento, index) => (
        <div
            className='div-perfis-de-usuario centralizar'
            style={{ backgroundColor: differenceInDays(new Date(), parseISO(equipamento.alterado_em)) <= 30 ? 'green' : 'rgb(0, 103, 155)' }}
            onClick={() => navigate('/DriveITEditarEquipamentos', {
                    state: {
                        user: user,
                        equipamentos: equipamento,
                        rooms: [...new Set(equipamentos.map(e => e.room).filter(Boolean))],
                        modelos: [...new Set(equipamentos.map(e => e.id_modelo).filter(Boolean))]
                    }
                    })}
            key={equipamento.numero_serie}
        >
            <div className='left'>
                {visibleFields.numero_serie && <p>{equipamento.numero_serie}</p>}
                {visibleFields.atribuido_a && <p>{equipamento.atribuido_a}</p>}
                {visibleFields.id_modelo && <p>{equipamento.id_modelo}</p>}
                {visibleFields.room && <p>{equipamento.room}</p>}
                {visibleFields.floor && <p>{equipamento.floor}</p>}               

                
            </div>
            <div className='right'>
                <p>{equipamento.nome}</p>
                <FontAwesomeIcon
                    icon={faCopy}
                    title="Copiar equipamento"
                    style={{ marginLeft: '10px', cursor: 'pointer' }}
                    onClick={(e) => {
                        e.stopPropagation();
                        navigate('/DriveIT_CriarEquipamentos', {
                            state: {
                                user: user,
                                equipamentos: equipamento,
                                rooms: [...new Set(equipamentos.map(e => e.room).filter(Boolean))],
                                modelos: [...new Set(equipamentos.map(e => e.id_modelo).filter(Boolean))]
                            }
                        });
                    }}
                />
            </div>

        </div>
    );

    if (loading) {
        return <div>Carregando equipamentos...</div>;
    }

    return (
        <>
            <main>

                <p className="texto-principal-da-pagina">Selecione o equipamento para editar</p>
                <form
                    style={{ display: 'flex', position: 'relative', flexDirection: 'column', alignItems: 'center' }}

                >
                <input
                type="file"
                accept=".xlsx,.xls,.csv"
                onChange={handleFile}
                id="fileInput"
                style={{ display: 'none' }}
                />
                
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                    <FontAwesomeIcon
                        icon={faFileImport}
                        title="Importar equipamentos" 
                        style={{ fontSize: '32px', cursor: 'pointer' }}
                        onClick={() => document.getElementById('fileInput').click()}
                    />
                    <FontAwesomeIcon
                        icon={faFileExport}
                        title="Exportar equipamentos"
                        style={{ fontSize: '32px', cursor: 'pointer' }}
                        onClick={handleExport}
                    />
                    <FontAwesomeIcon 
                        icon={faPlus}
                        title="Criar equipamentos"
                        style={{  fontSize: '32px', cursor: 'pointer' }} 
                        onClick={() => navigate('/DriveIT_CriarEquipamentos', { state: { user, rooms: equipamentos.map(e => e.room).filter(Boolean), modelos: [...new Set(equipamentos.map(e => e.id_modelo).filter(Boolean))]  } })}
                    />
                    <FontAwesomeIcon 
                        icon={faTrash}
                        title="Arquivar equipamentos"
                        style={{  fontSize: '32px', cursor: 'pointer' }} 
                        onClick={archive}
                    />                                        
                </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      
                        <input
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value.toLocaleLowerCase())}
                            className="input-login"
                            type="text"
                            id="nickName"
                            placeholder="  Pesquisar equipamentos..."
                        />
                        {/* <FontAwesomeIcon 
                            icon={faCog} 
                            style={{ marginRight: '10px', cursor: 'pointer' }} 
                            onClick={() => setVisibleFieldsMenuOpen(!visibleFieldsMenuOpen)}
                        />  */}
                        {visibleFieldsMenuOpen && (
                            <div style={{ position: 'absolute', top: '30px', left: '0', background: 'white', border: '1px solid #ccc', borderRadius: '5px', zIndex: 1 }}>
                                <label style={{ display: 'block', padding: '5px 10px', cursor: 'pointer' }}>
                                    <input
                                        type='checkbox'
                                        checked={visibleFields.numero_serie}
                                        onChange={() => toggleFieldVisibility('numero_serie')}
                                    />
                                    Número de Série
                                </label>
                                <label style={{ display: 'block', padding: '5px 10px', cursor: 'pointer' }}>
                                    <input
                                        type='checkbox'
                                        checked={visibleFields.atribuido_a}
                                        onChange={() => toggleFieldVisibility('atribuido_a')}
                                    />
                                    Atribuído a
                                </label>
                                <label style={{ display: 'block', padding: '5px 10px', cursor: 'pointer' }}>
                                    <input
                                        type='checkbox'
                                        checked={visibleFields.id_modelo}
                                        onChange={() => toggleFieldVisibility('id_modelo')}
                                    />
                                    Modelo
                                </label> 
                                <label style={{ display: 'block', padding: '5px 10px', cursor: 'pointer' }}>
                                    <input
                                        type='checkbox'
                                        checked={visibleFields.categoria_modelo}
                                        onChange={() => toggleFieldVisibility('categoria_modelo')}
                                    />
                                    Categoria do equipamento
                                </label>
                                <label style={{ display: 'block', padding: '5px 10px', cursor: 'pointer' }}>
                                    <input
                                        type='checkbox'
                                        checked={visibleFields.room}
                                        onChange={() => toggleFieldVisibility('room')}
                                    />
                                    Room
                                </label>
                                <label style={{ display: 'block', padding: '5px 10px', cursor: 'pointer' }}>
                                    <input
                                        type='checkbox'
                                        checked={visibleFields.floor}
                                        onChange={() => toggleFieldVisibility('floor')}
                                    />
                                    Floor
                                </label>
                                <label style={{ display: 'block', padding: '5px 10px', cursor: 'pointer' }}>
                                    <input
                                        type='checkbox'
                                        checked={visibleFields.estado}
                                        onChange={() => toggleFieldVisibility('estado')}
                                    />
                                    Status
                                </label>
                                <label style={{ display: 'block', padding: '5px 10px', cursor: 'pointer' }}>
                                    <input
                                        type='checkbox'
                                        checked={visibleFields.subestado}
                                        onChange={() => toggleFieldVisibility('subestado')}
                                    />
                                    Sub-Status
                                </label>
                                <label style={{ display: 'block', padding: '5px 10px', cursor: 'pointer' }}>
                                    <input
                                        type='checkbox'
                                        checked={visibleFields.grupo_suporte}
                                        onChange={() => toggleFieldVisibility('grupo_suporte')}
                                    />
                                    Grupo de Suporte
                                </label>
                                <label style={{ display: 'block', padding: '5px 10px', cursor: 'pointer' }}>
                                    <input
                                        type='checkbox'
                                        checked={visibleFields.centro_custos}
                                        onChange={() => toggleFieldVisibility('centro_custos')}
                                    />
                                    Centro de custos
                                </label> 
                                <label style={{ display: 'block', padding: '5px 10px', cursor: 'pointer' }}>
                                    <input
                                        type='checkbox'
                                        checked={visibleFields.deposito}
                                        onChange={() => toggleFieldVisibility('deposito')}
                                    />
                                    Depósito
                                </label>                                                           
                                
                            </div>
                        )}                         
                    </div>
                    <div style={{ display: 'flex', gap: '0px', marginBottom: '0px' }}>
                        <button 
                            className={`button-medio ${filtroSelecionado === 'ENCONTRADO' ? 'botao-selecionado' : ''}`}
                            onClick={(e) => {
                                e.preventDefault();
                                handleFilterChange('ENCONTRADO');
                            }}
                        >
                            ENCONTRADO
                        </button>
                        <button 
                            className={`button-medio ${filtroSelecionado === 'DESAPARECIDO' ? 'botao-selecionado' : ''}`}
                            onClick={(e) => {
                                e.preventDefault();
                                handleFilterChange('DESAPARECIDO');
                            }}
                        >
                            DESAPARECIDO
                        </button>
                        <button 
                            className={`button-medio ${filtroSelecionado === 'NÃO ENCONTRADO' ? 'botao-selecionado' : ''}`}
                            onClick={(e) => {
                                e.preventDefault();
                                handleFilterChange('NÃO ENCONTRADO');
                            }}
                        >
                            NÃO ENCONTRADO
                        </button>
                    </div>
                    <div style={{ display: 'flex', gap: '0px', marginBottom: '0px' }}>
                        <button className='button-medio'
                        onClick={(e) => {
                            e.preventDefault();
                            handleFilterChange('RECENTE');
                        }}                         
                        >
                        HISTÓRICO
                        </button>
                    </div>                    
                </form>
                
                <FlatList
                    list={filtered}
                    searchBy={["numero_serie", "nome", "room", "floor", "atribuido_a","centro_custos","estado","locacao_atual","local", "subestado", "categoria_modelo"]}
                    searchTerm={searchValue}
                    searchCaseInsensitive
                    renderItem={renderItem}
                    renderWhenEmpty={() => <div>Não há equipamentos cadastrados!</div>}
                />

                
                <footer>
                    <img src={atos} className='footer-alinhamento Atos-logo' alt='logo atos'></img>
                </footer>

            </main>
        </>
    );
}

export default Agendamentos;
